var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { forwardRef } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { BreadcrumbList, BreadcrumbListItem, BreadcrumbWrapper, BreadcrumbListArrow, LinkStyled } from './styles';
import Text from '../Text';
import { sendClickEvent } from './sendClickEvent';
export const Breadcrumb = forwardRef((_a, ref) => {
  var {
      links
    } = _a,
    props = __rest(_a, ["links"]);
  const linksCount = links.length;
  if (linksCount === 0) {
    return React.createElement(React.Fragment, null);
  }
  return React.createElement(BreadcrumbWrapper, Object.assign({}, props, {
    ref: ref,
    "data-testid": "breadcrumb-wrapper",
    "data-ds-component": "DS-Breadcrumb",
    "aria-label": "Atalhos de navega\u00E7\u00E3o"
  }), React.createElement(BreadcrumbList, null, links.map((_ref, index) => {
    let {
      url,
      label
    } = _ref;
    return React.createElement(BreadcrumbListItem, {
      key: "breadcrumb-".concat(label),
      paddingLeft: !url ? '--spacing-0-25' : undefined
    }, (() => {
      if (!url) {
        return React.createElement(Text.Caption, {
          weight: "semibold"
        }, label);
      }
      return React.createElement(LinkStyled, {
        href: url,
        key: url,
        variant: "grey",
        onClick: () => sendClickEvent(),
        dsParentName: "Breadcrumb"
      }, label);
    })(), index < linksCount - 1 ? React.createElement(BreadcrumbListArrow, null) : null);
  })));
});
Breadcrumb.displayName = 'Breadcrumb';